// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const MoreVertical = ({ fill, svgComponents: { G, Path } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    return (
        <G {...gProps}>
            <Path d="M32.44,23.56A3.56,3.56,0,1,0,28.89,20,3.56,3.56,0,0,0,32.44,23.56ZM20,23.56A3.56,3.56,0,1,0,16.44,20,3.56,3.56,0,0,0,20,23.56Zm-12.44,0A3.56,3.56,0,1,0,4,20,3.56,3.56,0,0,0,7.56,23.56Z" />
        </G>
    );
};

export default MoreVertical;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/general/more-vertical/index.js